module.exports = __webpack_public_path__ + "static/media/ic_business_account.625bec96.svg";